// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"b7dd89d7552f4cb2b471","883":"03f18979dea742dc6bde"}[chunkId] + ".js";
};